export const UPDATE_SELECTED_STORE_ID = 'stores/UPDATE_SELECTED_STORE_ID'
export const UPDATE_STORES = 'stores/UPDATE_STORES'
export const UPDATE_STORE_ID_LIST = 'stores/UPDATE_STORE_ID_LIST'

